<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner bottom">
        <div class="modal">
          <div class="modal-con">
            <EmoticonCard
              :items="FUNERAL_EMOTICON_LIST"
              :selected="state.index"
              :menu="state.menu"
              v-if="state.menu === EMOTICON_MENU.NORMAL"
              @click="fnEmojiPick"
              :is-notice="isNotice"
            />
          </div>
          <div class="modal-btn">
            <div class="btn-wrap">
              <button class="btn border-gray" @click="close">닫기</button>
              <button class="btn" @click="fnFetch">선택</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { onBeforeMount, reactive } from 'vue';
import { EMOTICON_MENU, FUNERAL_EMOTICON_LIST } from '@/common/constants/ConstCode';
import EmoticonCard from '@/components/common/funeral/EmoticonCard.vue';
const props = defineProps(['data']);
const emits = defineEmits(['close']);
const { fnCallBack, isNotice = true } = props.data;

onBeforeMount(async () => {
  fnEmojiPick(FUNERAL_EMOTICON_LIST?.value[0]);
});

const state = reactive({
  emoticon: '',
  emoticonNo: '',
  index: 0,
  menu: EMOTICON_MENU.NORMAL,
  list: FUNERAL_EMOTICON_LIST
});

const fnEmojiPick = (item, index = 0) => {
  state.emoticon = item?.file?.storedFileName;
  state.emoticonNo = item?.productNo;
  state.index = index;
};

const fnFetch = () => {
  if (fnCallBack) fnCallBack(state);

  setTimeout(() => {
    emits('close');
  }, 200);
};
const close = () => {
  setTimeout(() => {
    emits('close');
  }, 200);
};
</script>

<style scoped></style>
